export const SEARCH_KEYS = {
  users: ['id', 'name'],
  menus: ['game', 'server']
};